import type { FunctionComponent } from "react";
import { WalletTransactionsListAdminPartial } from "../../../partials/admin/wallet-transactions/wallet-transactions-list.admin.partials";
import { WalletTransactionsHeaderTabs } from "../../../partials/admin/wallet-transactions/wallet-transactions-header.admin.partials";
import { useParams } from "react-router-dom";
import { NotFound } from "../../../components/not-found.components";

export const WalletTransactionsDataAdminScreen: FunctionComponent = () => {
	const params = useParams<{ tab: WalletTransactionsHeaderTabs }>();

	function get() {
		switch (params.tab) {
			case WalletTransactionsHeaderTabs.GST_APPROVAL:
			case WalletTransactionsHeaderTabs.INVOICE_APPROVAL:
				return <WalletTransactionsListAdminPartial tab={params.tab} />;
			default:
				return <NotFound />;
		}
	}

	return (
		<>
			{/* <WalletTransactionsActionBarAdminPartial /> */}
			<div className="z-0 relative flex flex-1 mx-10 mt-4">{get()}</div>
		</>
	);
};
